import * as HLF from "html-living-framework";
import * as Constants from "../Data/Constants";
import { PatchData } from "../Data/PatchData";
import * as PatchTemplates from "../Data/PatchTemplates";
import * as QuiltData from "../Data/QuiltData";
import { Patch } from "../GameObjects/Patch";

export class PatchFactory {
    private static UNIQUE_PROBABILITY: number = 0.15;
    private static UNIQUE_PREFIX: string = "unique-";
    private static BASIC_PREFIX: string = "basic-";

    public static random(pQuiltIndex: number, pExclude: string[]): Patch {
        const data: QuiltData.QuiltData = QuiltData.DATA[pQuiltIndex];
        const unique: boolean = data.allowUnique && (Math.random() < PatchFactory.UNIQUE_PROBABILITY);
        let index: number;
        let asset: string | undefined;
        if (unique) {
            // Ensure we pick a fabric that isn't in use by any of the patches in the pExclude array
            while (asset === undefined) {
                index = HLF.Random.intBetween(0, PatchTemplates.UNIQUE.length);
                asset = PatchFactory.UNIQUE_PREFIX + pQuiltIndex + "-" + HLF.NumberUtils.addZeroPadding(index, 2);
                for (let i = 0; i < pExclude.length; ++i) {
                    if (pExclude[i] === asset) {
                        asset = undefined;
                        break;
                    }
                }
            }
            return new Patch(new PatchData(
                PatchTemplates.UNIQUE[index!],
                asset,
                Constants.SPRITESHEET_QUILT_PREFIX + "0" + pQuiltIndex,
                PatchTemplates.UNIQUE[index!].isRotatable ? HLF.Random.intBetween(0, 4) : 0,
                data.scale,
                data.allowDecal,
            ));
        }
        else {
            // Ensure we pick a fabric that isn't in use by any of the patches in the pExclude array
            while (asset === undefined) {
                index = HLF.Random.intBetween(0, data.patternCount);
                asset = PatchFactory.BASIC_PREFIX + pQuiltIndex + "-" + HLF.NumberUtils.addZeroPadding(index, 2);
                for (let i = 0; i < pExclude.length; ++i) {
                    if (pExclude[i] === asset) {
                        asset = undefined;
                        break;
                    }
                }
            }
            return new Patch(new PatchData(
                PatchTemplates.randomBasic(data.shapes),
                asset,
                Constants.SPRITESHEET_QUILT_PREFIX + "0" + pQuiltIndex,
                HLF.Random.intBetween(0, 4),
                data.scale,
                data.allowDecal,
                HLF.Random.intBetweenPoint(data.ramps),
            ));
        }
    }
}
